module.exports = __webpack_public_path__ + "img/debe_menu_brands.c43009fa.png";